import type { ExternalTableSchema } from '@packages/table-builder';

/**
 * DynamicTableV2 schema for the Job Scheduler list page.
 * Migrated from legacy src/pages/job-scheduler (identifier JOB_SCHEDULER).
 */
export const jobSchedulerTable: ExternalTableSchema = {
  metadata: {
    title: 'Job Scheduler',
    entity: 'JobScheduler',
    description: 'Job Scheduler list.',
  },

  dataSource: {
    endpoint: '/api/scheduler/api/app/schedule',
    method: 'GET',
    rowIdField: 'id',
    responseMapping: {
      items: 'items',
      totalCount: 'totalCount',
    },
    requestParams: {
      SearchKeyword: 'table.searchText',
      Sorting: 'table.sorting',
      SkipCount: 'table.pageOffset',
      MaxResultCount: 'table.pageSize',
      FromCreatedDate: 'filters.fromCreatedDate',
      ToCreatedDate: 'filters.toCreatedDate',
      TaskTypeIds: 'filters.taskTypeIds',
      TimeZone: 'filters.timeZone',
    },
    filters: [
      {
        name: 'fromCreatedDate',
        semanticId: 'fromCreatedDate',
        placeholder: 'From Created Date',
        type: 'date',
      },
      {
        name: 'toCreatedDate',
        semanticId: 'toCreatedDate',
        placeholder: 'To Created Date',
        type: 'date',
      },
      {
        name: 'taskTypeIds',
        semanticId: 'taskTypeIds',
        placeholder: 'Task Type',
        type: 'asyncSelect',
        dataSource: {
          url: '/api/scheduler/api/app/task-type/task-types',
          labelField: 'displayName',
          valueField: 'id',
        },
      },
    ],
  },

  columns: [
    { field: 'name', header: 'Name', type: 'text', sortable: true, width: 180 },
    {
      field: 'recurrenceStartDateTime',
      header: 'Start Date and Time',
      type: 'dateTime',
      sortable: false,
      width: 180,
    },
    {
      field: 'nextEventDate',
      header: 'Next Event Date',
      type: 'date',
      width: 150,
    },
    { field: 'nextEventTime', header: 'Next Event Time', type: 'text', width: 150 },
    { field: 'recurrence', header: 'Recurrence', type: 'text', sortable: true, width: 120 },
    { field: 'taskType', header: 'Task Type', type: 'text', sortable: true, width: 150 },
    {
      field: 'status',
      header: 'Status',
      type: 'badge',
      sortable: true,
      width: 200,
      align: 'center',
      badge: {
        statusMap: { Active: 'success', Disabled: 'error' },
        defaultVariant: 'default',
      },
    },
    {
      field: 'createdDate',
      header: 'Created Date',
      type: 'date',
      sortable: true,
      width: 170,
    },
    { field: 'createdBy', header: 'Created By', type: 'text', width: 150 },
    { field: 'taskRunBy', header: 'Task Run By', type: 'text', width: 150 },
  ],

  actions: {
    row: [
      { id: 'VIEW_JOB_SCHEDULER', label: 'View', semanticId: 'viewScheduleAction' },
      { id: 'EDIT_JOB_SCHEDULER', label: 'Edit', semanticId: 'editScheduleAction' },
      {
        id: 'ACTIVATE_JOB_SCHEDULER',
        label: 'Activate',
        semanticId: 'activateScheduleAction',
        visibilityCondition: { field: 'status', operator: 'NOT_EQUAL', value: 'Active' },
      },
      {
        id: 'DISABLE_JOB_SCHEDULER',
        label: 'Disable',
        semanticId: 'disableScheduleAction',
        visibilityCondition: { field: 'status', operator: 'NOT_EQUAL', value: 'Disabled' },
      },
      { id: 'VIEW_LOGS_JOB_SCHEDULER', label: 'View Logs', semanticId: 'viewLogScheduleAction' },
    ],
    toolbar: {
      primary: {
        id: 'ADD_JOB_SCHEDULER',
        label: 'Add Scheduled Task',
        icon: 'add_circle_outline',
        semanticId: 'addScheduledTaskButton',
      },
    },
  },

  features: {
    search: { enabled: true },
    pagination: { mode: 'infiniteScroll', defaultSize: 50 },
    columnPreferences: { persistenceKey: 'JOB_SCHEDULER', resizable: true, reorderable: true },
  },
};
